import { Component } from '@angular/core'

import { CalendarService } from '../../services/calendar.service'
import { EventsService } from '../../services/events.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'

import { Observable } from 'rxjs/Observable'

import * as moment from 'moment'
moment.locale('fr')

import { Event } from '../../models/event.model'

@Component({
  selector: 'ld-calendar',
  template: require('./calendar.component.html'),
  styles: [require('./calendar.component.css')],
  providers: [CalendarService]
})
export class CalendarComponent {

  private calendar = { table: [], selectedDay: { events: [] } }
  private currentDate = moment.utc()

  constructor (
    private calendarService: CalendarService,
    private eventsService: EventsService,
    private messagesDelegate: MessagesDelegate) {
    this.updateDate(moment.utc())
  }

  async updateDate (date) {
    const { from, to } = this.calendarService.getMonthRange(date)

    const events = await this.eventsService.find({ from, to })
      .catch((e) => {
        this.messagesDelegate.add('APP.EVENTSLIST.ERROR')
        return []
      })

    this.calendar = this.calendarService.create(this.currentDate, events)
  }

  selectDay (dayIndex) {
    this.calendar.selectedDay = this.calendarService.refreshSelectedDay(dayIndex)
  }

  eventTitleAlreadyDisplayed (previousDay, event) {
    return previousDay.eventsByLine.find(ev => ev === event)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/calendar/calendar.component.ts